import * as React from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Switch,
    TextField,
} from "@mui/material";
import {useTranslation} from "react-i18next";

export interface CreateJobPositionDialogProps {
    open: boolean;
    name: string;
    setName: (name: string) => void;
    active: boolean;
    setActive: (active: boolean) => void;
    saving: boolean;
    onClose: () => void;
    onSave: () => void;
}

export default function CreateJobPositionDialog({
    open,
    name,
    setName,
    active,
    setActive,
    saving,
    onClose,
    onSave,
}: Readonly<CreateJobPositionDialogProps>): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("hr.jobs.addPosition.title")}</DialogTitle>
            <DialogContent>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2, mt: 1}}>
                    <TextField
                        autoFocus
                        size="small"
                        fullWidth
                        label={t("hr.jobs.addPosition.placeholder")}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && name.trim() && !saving) onSave();
                        }}
                    />
                    <FormControlLabel
                        control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)}/>}
                        label={t("common.status.active")}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={saving}>{t("common.actions.cancel")}</Button>
                <Button variant="contained" onClick={onSave} disabled={!name.trim() || saving}
                        startIcon={saving ? <CircularProgress size={16}/> : undefined}>
                    {t("hr.jobs.addPosition.button")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
